export function sanitizeForFilename(text: string, _preserveSpaces = true, removeMarkdown = false): string {
  let sanitized = text;

  if (removeMarkdown) {
    sanitized = sanitized
      .replace(/\*\*(.+?)\*\*/g, "$1")
      .replace(/\*(.+?)\*/g, "$1")
      .replace(/`(.+?)`/g, "$1");
  }

  sanitized = sanitized.replace(/<[^>]+>/g, "");

  // Windows/Unix invalid filename characters: < > : " / \ | ? *
  sanitized = sanitized.replace(/[<>:"/\\|?*]/g, "");

  // Control characters (char codes 0-31)
  sanitized = sanitized
    .split("")
    .map((char) => {
      const code = char.charCodeAt(0);
      return code >= 0 && code <= 31 ? "" : char;
    })
    .join("")
    .trim()
    .replace(/\s+/g, " ");

  return sanitized;
}

/** content may be a Blob so already-binary payloads (images) download unmodified. */
export function downloadFile(content: string | Blob, filename: string, mimeType: string): void {
  if (typeof window === "undefined") return;

  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
